import { render, staticRenderFns } from "./ItemSpecifics.vue?vue&type=template&id=5b9f6fdb&"
import script from "./ItemSpecifics.vue?vue&type=script&lang=js&"
export * from "./ItemSpecifics.vue?vue&type=script&lang=js&"
import style0 from "./ItemSpecifics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ItemSpecifics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports